<template>
  <div class="percentage-chart">
    <div class="item" v-for="item in data" :key="item.title">
      <div class="title">{{ item.title }}</div>
      <div class="value">
        <span>{{ item.value }}%</span>
        <div class="progress-bar">
          <div
            class="progress-bar-inner"
            :style="{ width: item.value + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
// 这里可以引入 props 或后续逻辑
const data = [
  {
    type: "image",
    title: "清晰度合格率",
    value: 80.67,
  },
  {
    type: "image",
    title: "伪影率",
    value: 0.02,
  },
  {
    type: "image",
    title: "噪声指数合格率",
    value: 95.68,
  },
  {
    type: "report",
    title: "初写报告规范率",
    value: 79.48,
  },
  {
    type: "report",
    title: "审核报告规范率",
    value: 94.99,
  },
  {
    type: "report",
    title: "前列腺PI-RADS分类率",
    value: 3.61,
  },
  {
    type: "report",
    title: "乳腺BI-RADS分类率",
    value: 22.22,
  },
  {
    type: "security",
    title: "危急值报告上报率",
    value: 82.04,
  },
  {
    type: "security",
    title: "患者受照射剂量合格率",
    value: 99.99,
  },
];
</script>
<style scoped lang="less">
@import "@/assets/css/global.less";
.percentage-chart {
  width: 100%;
  background-color: @card-background-color;
  border-radius: 8px;
  padding: 10px;
  .item {
    display: flex;
    flex-direction: row;
    gap: 10px;
    line-height: @bar-chart-box-height;
    .title {
      font-size: 14px;
      color: @text-color-secondary;
      flex: 0 0 140px;
      text-align: right;
    }
    .value {
      flex: 1;
      text-align: left;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;
      span {
        position: absolute;
        left: 10px;
        top: 0;
        font-size: 18px;
        color: @text-color;
      }
      .progress-bar {
        width: 100%;
        height: @bar-chart-height;
        .progress-bar-inner {
          height: 100%;
          background-color: @card-border-color;
          border-radius: 10px;
          transition: width 0.3s;
          display: block;
        }
      }
    }
  }
}
</style>
